import script from "./7.SkinTypeDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./7.SkinTypeDescription.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__